import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Header } from '@/components/Header';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50">
      <Header />
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <Card className="shadow-xl border-0">
          <CardContent className="p-8">
            <h1 className="text-4xl font-bold text-center mb-8 text-primary">About Us</h1>
            
            <div className="prose prose-lg max-w-none text-muted-foreground leading-relaxed space-y-6">
              <p>
                Hi, I'm Rory, founder of Bins and Things, proud Highfields resident, husband, and dad to three lively kids (trust me, our bins are particularly smelly!).
              </p>
              
              <p>
                Bins and Things began right here in our neighbourhood, when I realised no one wanted to tackle the dirty job of bin cleaning, especially not in a busy family home like ours. After chatting with neighbours on Highfields and seeing the need for a proper, eco-friendly service, I decided to do something about it.
              </p>
              
              <p>
                Before launching Bins and Things, I spent 8 years as a Royal Marine Commando. Preparation, perfection, and the commando ethos are at the heart of everything I do, so you can expect a service that's reliable, thorough, and always ready for action. We're not just about cleaning bins, we're about raising standards and making life easier for our community.
              </p>
              
              <p>
                We're local, SEPA-compliant, and passionate about the environment. Our team uses eco-safe products and smart scheduling to keep your bins fresh and your driveways spotless, all while following the highest standards because that's what I'd expect for my own family.
              </p>
              
              <p>
                So whether you're a busy parent, a business owner, or just someone who'd rather not deal with smelly bins, we're here to help. Thanks for supporting a local business with a big heart (and a strong stomach!).
              </p>
              
              <p className="text-primary font-semibold text-xl text-center">
                Ready to join the clean bin revolution? We'd love to welcome you to the Bins and Things family.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AboutUs;